module.exports = __webpack_public_path__ + "static/media/pending.1551b094.gif";